import React from 'react';
import { Box } from '@mui/material';
import Seo from './Seo';
import HeaderArticle from './HeaderArticle';
import PageHero from './PageHero';
import Contact from './Contact';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';

// Shared chrome for every dedicated page: SEO head, sticky header, hero band,
// the page body, a Contact section (so the #rs-contact nav anchor resolves on
// every page), footer and the back-to-top button.
function PageLayout({ seo, hero, children, hideContact }) {
  return (
    <>
      <Seo {...seo} />
      <HeaderArticle />
      <PageHero {...hero} />
      <Box component="main">{children}</Box>
      {!hideContact && <Contact />}
      <Footer />
      <ScrollToTop />
    </>
  );
}

export default PageLayout;
